//@ts-nocheck
import React, { Suspense, useEffect, useMemo, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'setup'
import { setOrderSubtype } from 'app/features/orders/redux/order/orderSlice'
import OrderSubtypeSelector from 'app/components/OrderSubtype/OrderSubtypeSelector'

const OrderSubtypeWrapper: React.FC = () => {
  const dispatch = useDispatch()
  const order = useSelector((state: RootState) => state.orders.orderView.viewOrder)


  const handleSubtypeChange = useCallback((subtype: {id: string | null; name: string | null}) => {
    if (subtype && subtype.id) {
      dispatch(setOrderSubtype({ id: subtype.id, name: subtype.name}))
    } else {
      dispatch(setOrderSubtype({ id: null, name: null}))
    }
  }, [dispatch])

  return (
    <div className='card rounded shadow-sm mb-5 mb-xl-8'>
      <div className='card-body py-3'>
        <Suspense fallback={<div>Loading...</div>}>
          <OrderSubtypeSelector
            value={order.orderSubtype}
            onChange={handleSubtypeChange}
            orderId={order.id}
          />
        </Suspense>
      </div>
    </div>
  )
}

export default OrderSubtypeWrapper